export function parseAndAppendQueryParameters(
  appendTo: string,
  appendFrom: string,
): string {
  const parsed = new URL(appendFrom);
  const url = new URL(appendTo);

  parsed.searchParams.delete('action');
  parsed.searchParams.forEach((key, value) => {
    url.searchParams.append(value, key);
  });

  return url.href;
}
